import item from "./item";
import group from "./group";

export default {
  name: "DsfCustomDropTreeLogicNode",
  components: {
    item,
    group
  },
  inject: {
    $customDropTree: {
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return null
      }
    }
  },
  created() {
    if (this.data && this.$customDropTree) {
      this.$customDropTree.setNode(this.data);
    }
  },
  methods: {
    renderGroup(h, data) {
      return (
        <group props={{ data: data }} scopedSlots={{
          default: ({data}) => {
            return this.$scopedSlots.default({
              data: data
            })
          },
          more: ({data}) => {
            return this.$scopedSlots.more({
              data: data
            })
          },
          bottom: ({data}) => {
            return this.$scopedSlots.bottom({
              data: data
            })
          }
        }}/>
      );
    },
    renderItem(h, data) {
      return (
        <item props={{ data: data }} scopedSlots={{
          default: ({data}) => {
            return this.$scopedSlots.default({
              data: data
            })
          },
          more: ({data}) => {
            return this.$scopedSlots.more({
              data: data
            })
          },
          bottom: ({data}) => {
            return this.$scopedSlots.bottom({
              data: data
            })
          }
        }}/>
      )
    }
  },
  render(h) {
    if (this.data.isGroup) {
      if (this.data.items.length > 1) {
        return this.renderGroup(h, this.data);
      }
      else if (this.data.items.length == 1) {
        let data = this.data.items[0];
        if (data?.items?.length > 1) {
          return this.renderGroup(h, data);
        }
        else if (data?.items?.length == 1) {
          return this.renderItem(h, data.items[0]);
        }
        else {
          return this.renderItem(h, data);
        }
      }
    }
    else if (this.data.isLeaf && dsf.isDef(this.data.field)) {
      return this.renderItem(h, this.data);
    }
    return h();
  }
};